/**
 * 全局过滤器
 */

/**
 * 格式化日期时间
 * 将 2026-07-29T08:38:48.000000Z 或 2026-07-29 08:38:48 等格式
 * 转换为 2026-07-29 08:38:48
 * @param {string|number} value - 时间值
 * @param {string} format - 格式: 'datetime' | 'date' | 'time'
 */
export function formatDateTime(value, format = 'datetime') {
  if (!value) return '-'
  try {
    const date = new Date(value)
    // 检查日期是否有效
    if (isNaN(date.getTime())) return value

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hour = String(date.getHours()).padStart(2, '0')
    const minute = String(date.getMinutes()).padStart(2, '0')
    const second = String(date.getSeconds()).padStart(2, '0')

    if (format === 'date') {
      return `${year}-${month}-${day}`
    }
    if (format === 'time') {
      return `${hour}:${minute}:${second}`
    }
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  } catch (e) {
    return value
  }
}
